const CallingCard = ({ phone, children }) => {
    return (
        <div id="calling-card" onClick={() => handleClick(phone)}>
            {children}
        </div>
    );
};

const handleClick = phone => {
    // use browser to call phone number
    window.location.href = `tel:${phone}`;
};

export default CallingCard;
